<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';
import { frontendURL } from 'dashboard/helper/URLHelper';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const getters = useStoreGetters();
const accountId = getters.getCurrentAccountId;

const integrations = computed(
  () => getters['googleAds/getGoogleAds']?.value || []
);

const isConfigured = computed(() => integrations.value.length > 0);

const integrationStatus = computed(() =>
  isConfigured.value
    ? t('INTEGRATION_APPS.STATUS.ENABLED')
    : t('INTEGRATION_APPS.STATUS.DISABLED')
);

const integrationStatusColor = computed(() =>
  isConfigured.value ? 'bg-n-teal-9' : 'bg-n-slate-8'
);

const actionURL = computed(() =>
  frontendURL(`accounts/${accountId.value}/settings/integrations/google_ads`)
);
</script>

<template>
  <div
    class="flex flex-col flex-1 p-6 m-[1px] outline outline-n-container outline-1 bg-n-alpha-3 rounded-md shadow"
  >
    <div class="flex items-start justify-between">
      <div
        class="flex h-12 w-12 mb-4 items-center justify-center rounded-md border border-n-weak bg-n-alpha-3"
      >
        <span class="i-lucide-badge-dollar-sign text-2xl text-n-slate-12" />
      </div>
      <span
        v-tooltip="integrationStatus"
        class="text-white p-0.5 rounded-full w-5 h-5 flex items-center justify-center"
        :class="integrationStatusColor"
      >
        <i class="i-ph-check-bold text-sm" />
      </span>
    </div>
    <div class="flex flex-col m-0 flex-1">
      <div
        class="font-medium mb-2 text-n-slate-12 flex justify-between items-center"
      >
        <span class="text-base font-semibold">
          {{ $t('INTEGRATION_SETTINGS.GOOGLE_ADS.HEADER') }}
        </span>
        <router-link :to="actionURL">
          <Button :label="$t('INTEGRATION_APPS.CONFIGURE')" link />
        </router-link>
      </div>
      <p class="text-n-slate-11">
        {{ $t('INTEGRATION_SETTINGS.GOOGLE_ADS.DESCRIPTION') }}
      </p>
      <p v-if="isConfigured" class="text-sm text-n-slate-10 mt-2">
        {{
          integrations[0]?.account_name ||
          integrations[0]?.settings?.account_name ||
          $t('INTEGRATION_SETTINGS.GOOGLE_ADS.CONNECTED')
        }}
      </p>
      <p v-else class="text-sm text-n-slate-10 mt-2">
        {{ $t('INTEGRATION_SETTINGS.GOOGLE_ADS.EMPTY_STATE') }}
      </p>
    </div>
  </div>
</template>
